import React from 'react';
import "bootstrap/dist/css/bootstrap.css";
import '../../assets/css/style.css';

import RegistryTable from '../shared/RegistryTable_RT';
import PeriodAndDisplaySelector from '../shared/PeriodAndDisplaySelector';
import ItemMultiSelector from '../shared/ItemMultiSelector';

import * as api from '../../api/api';
import * as utils from '../../utils';

class UserDeviceActionsPage extends React.Component {
    constructor(props) {
        super(props);

        this.users = [];

        this.selectedDevices = [];
        this.selectedUsers = [];
        this.deviceActions = [];
        this.period = {
            startDate: null,
            endDate: null,
        };

        this.columns = [
            {
                Header: '_id',
                accessor: 'id',
            },
            {
                Header: '#',
                accessor: 'number',
            },
            {
                Header: 'Табло',
                accessor: 'deviceId',
            },
            {
                Header: 'Остановочный пункт',
                accessor: 'checkpoint',
            },
            {
                Header: 'Дата',
                accessor: 'dateTime',
            },
            {
                Header: 'Операция',
                accessor: 'action',
            },
            {
                Header: 'Пользователь',
                accessor: 'user',
            }
        ];

        this.state = {
            // deviceActions: [],
            // selectedDevices: [],
            // selectedUsers: [],
        }

        this.props.updateLoader({
            loaded: false,
            message: ""
        });

        this.getFilteredItems = this.getFilteredItems.bind(this);
        this.onMount = this.onMount.bind(this);
    }

    // onMount() {
    //     this.getFilteredItems();
    // }

    onMount() {
        api.makeRequest(api.getUsersDictionary())
            .then((users) => {
                this.users = users.data.data.map((user) => ({
                    value: user.id,
                    label: user.fio,
                }));
                console.log(this.users);

                this.setState({
                    selectedUsers: users.data.data.map((user) => (user.id)),
                }, () => this.getFilteredItems());
            })
            .catch((err) => {
                this.props.updateLoader({
                    loaded: true,
                    message: "Ошибка при получении данных: " + err
                });
            });
        // this.setState({
        //     users: allUsers.map((user) => ({
        //         value: user.id,
        //         label: user.fio,
        //     })),
        //     selectedUsers: allUsers.map((user) => (user.id)),
        // }, () => this.getFilteredItems());
    }

    // async componentDidMount() {
    //     const allUsers = (await api.makeRequest(api.getUsersDictionary())).data.data;
    //     this.setState({
    //         users: allUsers.map((user) => ({
    //             value: user.id,
    //             label: user.fio,
    //         })),
    //     }, async () => await this.getFilteredItems());
    // }

    async getFilteredItems() {

        let errors = [];

        // if (!this.state.startDate || !this.state.endDate) {
        //     errors.push(<li className="mb-2">Пожалуйста, выберите корректный период</li>);
        // }

        // if (!this.state.selectedUsers || this.state.selectedUsers.length === 0) {
        //     errors.push(<li className="mb-2">Пожалуйста, выберите пользователей</li>);
        // }

        // if (!this.state.selectedDevices || this.state.selectedDevices.length === 0) {
        //     errors.push(<li className="mb-2">Пожалуйста, выберите табло</li>);
        // }

        if (!this.period.startDate || !this.period.endDate) {
            errors.push(<li className="mb-2">Пожалуйста, выберите корректный период</li>);
        }

        if (!this.selectedUsers || this.selectedUsers.length === 0) {
            errors.push(<li className="mb-2">Пожалуйста, выберите пользователей</li>);
        }

        if (!this.selectedDevices || this.selectedDevices.length === 0) {
            errors.push(<li className="mb-2">Пожалуйста, выберите табло</li>);
        }

        if (errors.length > 0) {
            this.setState({
                errors: errors
            });

            return;
        }

        this.props.updateLoader({
            loaded: false,
            message: ""
        });

        try {
            // const allDevices = (await api.makeRequest(api.getDisplaysDictionary())).data.data;
            // const allUsers = (await api.makeRequest(api.getUsersDictionary())).data.data;

            // const listItems = [];

            // for (const deviceId of fileAssignments) {
            //     const deviceInfo = allDevices.find((device) => device.id === deviceId);
            //     listItems.push({
            //         value: deviceId,
            //         label: `${deviceInfo.id} [${deviceInfo.checkpoint.name} - ${deviceInfo.checkpoint.description}]`,
            //     });
            // }

            const userDeviceActions = (await api.makeRequest(api.getUserDeviceActions({
                // from: this.state.startDate,
                // to: this.state.endDate,
                // devices: this.state.selectedDevices,
                // users: this.state.selectedUsers,
                from: this.period.startDate,
                to: this.period.endDate,
                devices: this.selectedDevices,
                users: this.selectedUsers,
            }))).data.data;

            for (let i = 0; i < userDeviceActions.length; i++) {
                userDeviceActions[i].number = i + 1;
                userDeviceActions[i].checkpoint = utils.getCheckpointNiceName(userDeviceActions[i].checkpoint);
            }

            this.deviceActions = userDeviceActions;

            this.setState({
                // deviceActions: userDeviceActions,
                reportPeriodText: "Показаны данные за " + this.state.startDate + " - " + this.state.endDate,
                errors: null,
            });

            this.props.updateLoader({
                loaded: true,
                message: ""
            });
        } catch (err) {
            this.props.updateLoader({
                loaded: true,
                message: "Ошибка при получении данных: " + err
            });
        }
    }

    render() {

        // const displaySelectStyle = {
        //     control: styles => ({ ...styles, minWidth: '250px' })
        // };

        // const eventTypeSelectStyle = {
        //     control: styles => ({ ...styles, minWidth: '250px' })
        // };

        return (
            // <div style={{ width: 80 + 'vw' }}>
            <div>
                <div className="card card-collapse">
                    <div className="card-header">
                        <h5>
                            <a data-toggle="collapse" href="#filterBlock">
                                Фильтр
                            </a>
                        </h5>
                    </div>

                    <div className="collapse show" id="filterBlock">
                        <div className="card-body">

                            <PeriodAndDisplaySelector
                                // onDatesChange={(startDate, endDate) => { this.setState({ startDate, endDate }) }}
                                // onDisplaysChange={(selectedDevices) => { this.setState({ selectedDevices }) }}
                                onDatesChange={(startDate, endDate) => { this.period = { startDate, endDate }; }}
                                // onDisplaysChange={(selectedDevices) => { this.setState({ selectedDevices }) }}
                                onDisplaysChange={(selectedDevices) => { this.selectedDevices = selectedDevices; }}
                                updateLoader={this.props.updateLoader}
                                onMount={this.onMount}
                            />

                            <ItemMultiSelector
                                caption="Пользователи"
                                items={this.users}
                                onItemsChange={(value) => {
                                    // console.log(value)
                                    // this.setState({ selectedUsers: value })
                                    this.selectedUsers = value;
                                }}
                            />

                            {
                                this.state.errors &&
                                <div className="alert alert-warning p-2 mt-3" role="alert">
                                    Обнаружены ошибки:
                                    <ul className="mt-3">
                                        {this.state.errors}
                                    </ul>
                                </div>
                            }

                            <div className="d-flex justify-content-center mt-2">
                                <button className="btn btn-primary-custom" onClick={this.getFilteredItems}>
                                    Применить
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="card mt-5">
                    <div className="card-header">
                        <h5>Операции с устройствами</h5>
                    </div>

                    <div className="card-body">

                        {
                            this.state.reportPeriodText &&
                            <div class="alert alert-info mt-3 mb-3" role="alert">
                                {this.state.reportPeriodText}
                            </div>
                        }

                        <RegistryTable
                            columns={this.columns}
                            // data={this.state.deviceActions}
                            data={this.deviceActions}
                            showActions={false}
                            alwaysDisplayTable={false}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

export default UserDeviceActionsPage;